import type { RoomParticipantView, RoomView } from "../../shared/game";

// The badge counts the same rows the teacher sees, including Away/disconnected
// students. Presence counts remain separate for synchronization and gameplay.
export const getLobbyRosterParticipants = (room: RoomView): RoomParticipantView[] =>
    room.participants.filter((participant) =>
        !participant.isController && !participant.isHost &&
        !(room.viewer.isHost && participant.sessionId === room.viewer.sessionId)
    );

export const getConnectedLobbyRosterIds = (room: RoomView): string[] =>
    getLobbyRosterParticipants(room).filter((participant) => participant.connected)
        .map((participant) => participant.sessionId).sort();

export const getLobbyPlaygroundIds = (room: RoomView): string[] => {
    const hostIds = new Set(room.participants.filter((participant) => participant.isHost).map((participant) => participant.sessionId));
    if (room.viewer.isHost) hostIds.add(room.viewer.sessionId);
    return (room.lobbyPlayground?.players ?? []).filter((player) => player.connected && !hostIds.has(player.sessionId))
        .map((player) => player.sessionId).sort();
};

export const hasLobbyRosterMismatch = (room: RoomView): boolean =>
    room.phase === "lobby" && Boolean(room.lobbyPlayground) &&
    JSON.stringify(getConnectedLobbyRosterIds(room)) !== JSON.stringify(getLobbyPlaygroundIds(room));
